import { Injectable } from "@angular/core";
import { ConfigDocModelService } from "app/core/models/config-doc-model.service";
import { CourseContextModelService } from "../../models/course-context-model.service";
import { CourseStructureModelService } from "app/core/models/course-structure-model.service";
import { UtilityScripts } from "../../../helpers/utility-scripts";
import { ApplicationModel } from "app/core/models/application.model";

@Injectable()
export class PresentationModePopupModelService {
	public languages;
	public presentationMode;
	public selectedLang: String = "";
	public showDropdown: boolean = true;
	public selectedPresMode: String = "";
	public enabledNext: Boolean = false;
	public LanguagesLen: number;
	public bshow: Boolean = false;

	constructor(
		private configDocModel: ConfigDocModelService,
		private courseContextModel: CourseContextModelService,
		private courseStructureModel: CourseStructureModelService
	) {
		// this.languages = this.configDocModel.availableLanguages;
		// this.presentationMode = this.configDocModel.presentationModes;
		console.log(this.configDocModel.presentationModes);
	}
	public setLanguages(arr: any) {
		this.languages = arr;
		this.LanguagesLen = arr.length;
		if (this.LanguagesLen > 6) {
			this.bshow = true;
		}
	}
	public setLanguage(val) {
		this.selectedLang = val.language;
		ApplicationModel.instance.flowDirection = val.direction;
		this.presentationMode = this.configDocModel.presentationModes;
		//this.courseContextModel.currentLanguage =  language;
		// this.courseStructureModel.updateLanguage(language);
	}

	public setPresentationMode(mode) {
		this.selectedPresMode = mode;
		//this.configDocModel.setPresentationMode(mode);
	}
}
